import { render, staticRenderFns } from "./ChooseOrder.vue?vue&type=template&id=2bef2315&scoped=true&"
import script from "./ChooseOrder.vue?vue&type=script&lang=js&"
export * from "./ChooseOrder.vue?vue&type=script&lang=js&"
import style0 from "./ChooseOrder.vue?vue&type=style&index=0&id=2bef2315&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bef2315",
  null
  
)

export default component.exports